import authentications from './authentications.json';
import global from './global.json';
import header from './header.json';
import history from './history.json';
import numbers from './numbers.json';

export default {
  authentications,
  global,
  history,
  numbers,
  header,
};
